<template>
  <nav>
    <div class="nav-container">
      <div class="font-logo">
        PGG.MHC
      </div>
      <ul v-if="!foldNavLink" class="nav-items">
        <li class="nav-item">
          <router-link to="/home">
            Home
          </router-link>
        </li>
        <li class="nav-item">
          <router-link to="/hlaallele">
            HLA Alleles
          </router-link>
        </li>
        <li class="nav-item">
          <router-link to="/population">
            Populations
          </router-link>
        </li>
        <li class="nav-item">
          <el-dropdown>
            <span style="font-size:16px">
              Analysis
              <i class="el-icon-arrow-down el-icon--right" />
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <router-link active-class="sub-router-link-active" to="/tool/imputation">
                  <div class="dropdown-title">HLA Imputation</div>
                  Imputation of HLA alleles from genotyping data
                </router-link>
              </el-dropdown-item>
              <el-dropdown-item divided>
                <router-link active-class="sub-router-link-active" to="/tool/association">
                  <div class="dropdown-title">HLA Association</div>
                  Case/control studies for HLA-related phenotypes
                </router-link>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </li>
        <li class="nav-item">
          <router-link to="/statistics">
            Statistics
          </router-link>
        </li>
        <li class="nav-item">
          <router-link to="/help">
            Help
          </router-link>
        </li>
        <li class="nav-item">
          <router-link to="/about">
            About
          </router-link>
        </li>
      </ul>
      <el-dropdown v-else>
        <el-button>
          Menu<i class="el-icon-arrow-down el-icon--right" />
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item>
            <el-link :underline="false" href="#/">
              Home
            </el-link>
          </el-dropdown-item>
          <el-dropdown-item>
            <el-link :underline="false" href="#/hlaallele">
              HLA Alleles
            </el-link>
          </el-dropdown-item>
          <el-dropdown-item>
            <el-link :underline="false" href="#/population">
              Populations
            </el-link>
          </el-dropdown-item>
          <el-dropdown-item style="font-size:10px" disabled>Analysis</el-dropdown-item>
          <el-dropdown-item>
            <el-link :underline="false" href="#/tool/imputation">
              <span style="margin-left:15px">HLA Imputation</span>
            </el-link>
          </el-dropdown-item>
          <el-dropdown-item>
            <el-link :underline="false" href="#/tool/association">
              <span style="margin-left:15px">HLA Association</span>
            </el-link>
          </el-dropdown-item>
          <el-dropdown-item>
            <el-link :underline="false" href="#/statistics">
              Statistics
            </el-link>
          </el-dropdown-item>
          <el-dropdown-item>
            <el-link :underline="false" href="#/help">
              Help
            </el-link>
          </el-dropdown-item>
          <el-dropdown-item>
            <el-link :underline="false" href="#/about">
              About
            </el-link>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'PggNavbar',
  data() {
    return {
      foldNavLink: false
    }
  },
  mounted() {
    this.foldNavLink = window.innerWidth < 750
    window.addEventListener('resize', () => {
      if (!this.timer) { // 使用节流机制，降低函数被触发的频率
        this.timer = true
        const that = this
        setTimeout(function() {
          that.foldNavLink = window.innerWidth < 750
          that.timer = false
        }, 400)
      }
    })
  },
  methods: {
    navigate(path) {
      path === this.$route.path ? '' : this.$router.push(path)
    }
  }
}
</script>

<style lang="scss" scoped>
  // 导航栏布局
  nav {
    position: fixed;
    width: 100%;
    z-index: 2999;
    left: 0;
    top: 0;
    background-color: #fff;
    height: 56px;
    box-shadow: 0 0 1rem rgb(0 0 0 / 15%) !important;

    .nav-container {
      display:flex;/*Flex布局*/
      display: -webkit-flex; /* Safari */
      align-items:center;/*指定垂直居中*/
      justify-content: space-between;
      padding: 0 20px;
    }
  }

  // logo样式
  .font-logo {
    font-size: 1.5rem;
    font-weight: 580;
    line-height: 56px;
    color: #e83e8c;
  }

  // 导航栏dropdown的样式
  .el-dropdown {
    vertical-align: top;
  }
  .dropdown-title {
    font-weight: 550;
    font-size: 16px;
    line-height: 28px;
  }
  .el-dropdown + .el-dropdown {
    margin-left: 15px;
  }

  // 导航栏各元素的样式
  .nav-items {
    text-align: left;
    -webkit-margin-before: 0em;
    margin-block-start: 0em;
    -webkit-margin-after: 0em;
    margin-block-end: 0em;
    padding-inline-start: 0px;
    .nav-item {
      height: 100%;
      margin: 0;
      position: relative;
      cursor: pointer;
      display: inline-block;
      text-align: justify;
      line-height: 54.6px;
      padding: 0;
      margin: 0;
      margin-left: 1.3rem;
      font-size: 16px;
      >a {
      line-height: 50px;
    }
    }
    .el-link {
      font-size: 16px;
    }

  }
a {
  text-decoration: none;
  color: #606266;
}
.router-link-active {
  color: #409EFF;
  border-bottom: 2px solid #409EFF;
}
.sub-router-link-active {
  color: #409EFF;
}
</style>
